/**
 * Flatten a scheduling `student_profiles` response into a single selectable list.
 *
 * When loaded with `options[include][]=children`, each family head carries a
 * nested `children` array. This flattens each head + its children into sibling
 * rows, tagging every managed child so `SchedulingUserSelector`'s Option renders
 * it indented under its head; the last child closes the connecting tree line
 * into a corner instead of a tee. (CN-1323 / CFTB-3281)
 *
 * Shared by every scheduling athlete picker (session form, program registration,
 * offering assignment) so the tagging fields and ordering stay in lockstep.
 */
export function flattenFamilyStudentProfiles(students: any[]): any[] {
  return (students || []).flatMap((head: any) =>
    head.children?.length
      ? [
          head,
          ...head.children.map((child: any, i: number) => ({
            ...child,
            isFamilyChild: true,
            isLastFamilyChild: i === head.children.length - 1,
          })),
        ]
      : [head],
  );
}
